module.exports = __webpack_public_path__ + "media/stylesheets/images/maketing-tech-f7c8c8d5720ee1c0a2d19a9b57a1db05.svg";